<template>
  <v-container>
    <div class="container-inner">
      <div class="pageTitle" v-if='$route.name === "WarehousesList"'>
        <v-row>
          <v-col sm="6" md="7" lg="8" cols="12">
            <h1 class="main-title">Warehouses</h1>
          </v-col>
          <v-col sm="6" md="5" lg="4" cols="12">
            <div class="flex-nowrap align-center input-search">
              <v-text-field
                v-model="search"
                placeholder="Search"
                dense
                filled
                Outlined
                single-line
                hide-details="auto"
                background-color="white"
                prepend-inner-icon="mdi-magnify"
              />
            </div>
          </v-col>
        </v-row>
      </div>
      <router-view :searchQuery='search'/>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'WarehousesMain',
  data: function() {
    return {
      search: ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>
